// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3L_3s","container":"styles_container__1KrEH","title":"styles_title__1CaMV","wrapper":"styles_wrapper__1qiuv","answer":"styles_answer__Mq6Mq"};